/**
 * Created by andrey on 02.10.2025
 */

const ConnectorErrorHandler = {
    lastSend: 0,

    onError: function (event) {
        if (this.needIgnore(event)) {
            return;
        }

        const needSend = this.needSend();

        if (needSend) {
            this.send(event);
        }

        window.dispatchEvent(new CustomEvent("connector:globalError", {
            detail: {
                needSend,
                originalEvent: event
            }
        }));
    },

    send: function () {
        this.lastSend = Date.now();

        if (connector._metrics) {
            connector._metrics.logEvent(connector.EVENTS.STATS.ERROR_AMOUNT);
        }
    },

    needIgnore: function (event) {
        const message = [
            event.message,
            `Line: ${event.lineno}`,
            `Column: ${event.colno}`,
            typeof event.error === "string" && event.error,
            event.error && event.error.message,
            event.error && event.error.stack,
            event.filename
        ].filter(Boolean).join(" - ");

        const source = connector.info.source;

        return ConnectorErrorHandler.IGNORED_ERRORS.some((ignored) => message.includes(ignored))
            || event.lineno === 0 && event.colno === 0 && ConnectorErrorHandler.MUTED_SCRIPT_ERROR_SOURCES.includes(source)
            || event.lineno === 1 && source === "samsung" && message.includes("missing ) after argument list");
    },

    needSend: function () {
        return this.lastSend + ConnectorErrorHandler.SEND_INTERVAL < Date.now();
    }
};

ConnectorErrorHandler.SEND_INTERVAL = connector.utils.parseInterval("1 hour");

ConnectorErrorHandler.IGNORED_ERRORS = [
    "html5.api.gamedistribution.com",
    "hadronid.net/hadron.js",
    "app.mbga-platform.jp/gadgets/js/auth-refresh",
    "safari-extension://",
    "eval (eval at  anonymous  (eval at buildCode (:606:31))"
];

// Cross-origin <script>s loaded without crossorigin="anonymous" + a matching ACAO header
// throw errors muted by the browser to "Script error." with line=0 col=0. Unactionable, so
// we filter. To extend: re-curl the CDN with our partner Origin; if it now returns ACAO,
// drop the entry here AND remove `crossorigin: false` from sdkmanager.js for that loader.
// Last verified 2026-04-07.
ConnectorErrorHandler.MUTED_SCRIPT_ERROR_SOURCES = [
    "gdcom", // pre-existing carve-out
    "coolmath", // pre-existing carve-out
    "msstart", // assets.msn.com - ACAO allow-list hard-coded to https://www.msn.com only
    "kongregate", // cdn1.kongregate.com - no ACAO (Fastly/Varnish)
    "mymailru", // connect.mail.ru - no ACAO
    "ok", // api.ok.ru - no ACAO + sets ss_api session cookie that anonymous would strip
    "spmobage", // cdn-connect.mobage.jp - no ACAO
    "draugiem", // draugiem.lv - 301 redirect leg has no ACAO (final destination does)
    "samsung", // gtg.samsungapps.com / img.samsungapps.com - no ACAO; loaded from index.html
    "addicting" // cdn.intergient.com - Playwire RAMP no ACAO
];

window.addEventListener("error", (event) => ConnectorErrorHandler.onError(event));

Error.stackTraceLimit = 30;